// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2Ciry","header":"ReportDetails_header__1j6uX","title":"ReportDetails_title__vPQA7","left":"ReportDetails_left__kI2KM"};